(() => {
  const script = document.currentScript || document.querySelector('script[data-gd-search-intent]');
  const searchRoute = script?.dataset.gdSearchUrl;
  if (!searchRoute || document.documentElement.dataset.gdSearchIntentReady) return;
  document.documentElement.dataset.gdSearchIntentReady = 'true';

  const searchUrl = new URL(searchRoute, location.href);
  const inPreview = Boolean(document.querySelector('script[data-gd-theme]')?.dataset.gdTheme);
  const optionName = 'options[unavailable_products]';
  const hasUnderwaterIntent = query => /(^|[^a-z0-9])(?:underwater|rovs?|chasing)(?=$|[^a-z0-9])/i.test(query);
  const isSearchUrl = url => url.origin === searchUrl.origin && url.pathname.replace(/\/$/, '') === searchUrl.pathname.replace(/\/$/, '');

  // Shopify's preview redirect can serialize a nested options map as a string.
  // Accept only a complete string-to-string map; never combine unknown flat data with nested options.
  const normalizeFlatOptions = params => {
    if (!params.has('options')) return true;
    if (params.getAll('options').length !== 1) return false;
    const raw = params.get('options').trim();
    if (!raw.startsWith('{') || !raw.endsWith('}')) return false;
    const body = raw.slice(1, -1).trim();
    if (body.endsWith(',')) return false;
    const pair = /\s*("(?:[^"\\]|\\.)*")\s*(?:=>|:)\s*("(?:[^"\\]|\\.)*")\s*(?:,|$)/gy;
    const entries = new Map();
    let offset = 0;
    while (offset < body.length) {
      pair.lastIndex = offset;
      const match = pair.exec(body);
      if (!match) return false;
      let key, value;
      try { key = JSON.parse(match[1]); value = JSON.parse(match[2]); } catch { return false; }
      if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(key) || entries.has(key)) return false;
      const nestedName = `options[${key}]`;
      if ([...params.keys()].some(name => name.startsWith(`${nestedName}[`))) return false;
      if (nestedName !== optionName && params.getAll(nestedName).some(existing => existing !== value)) return false;
      entries.set(key, value);
      offset = pair.lastIndex;
    }
    params.delete('options');
    entries.forEach((value, key) => params.set(`options[${key}]`, value));
    return true;
  };

  const updateForm = form => {
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'get') return;
    const action = new URL(form.action, location.href);
    if (!isSearchUrl(action)) return;
    const query = form.elements.namedItem('q');
    if (!(query instanceof HTMLInputElement)) return;
    if (form.elements.namedItem('options')) return;
    const options = [...form.querySelectorAll(`input[name="${optionName}"]`)];
    if (!hasUnderwaterIntent(query.value)) {
      options.forEach(input => input.remove());
      return;
    }
    const input = options.shift() || document.createElement('input');
    input.type = 'hidden';
    input.name = optionName;
    input.value = 'show';
    if (!input.parentElement) form.append(input);
    options.forEach(duplicate => duplicate.remove());
  };

  const updateLink = link => {
    if (!(link instanceof HTMLAnchorElement) || !link.closest('.gd-search')) return;
    const url = new URL(link.href, location.href);
    if (!isSearchUrl(url) || !url.searchParams.has('q')) return;
    if (!normalizeFlatOptions(url.searchParams)) return;
    if (inPreview) url.searchParams.delete('preview_theme_id');
    if (hasUnderwaterIntent(url.searchParams.get('q'))) {
      url.searchParams.set(optionName, 'show');
    } else {
      url.searchParams.delete(optionName);
    }
    if (link.href !== url.href) link.href = url.href;
  };

  const decorate = scope => {
    scope.querySelectorAll('form').forEach(updateForm);
    scope.querySelectorAll('.gd-search a[href]').forEach(updateLink);
  };

  document.addEventListener('submit', event => updateForm(event.target), true);
  document.addEventListener('input', event => {
    if (event.target instanceof HTMLInputElement && event.target.name === 'q') updateForm(event.target.form);
  });
  document.addEventListener('click', event => {
    if (event.target instanceof Element) updateLink(event.target.closest('a[href]'));
  }, true);
  document.addEventListener('auxclick', event => {
    if (event.target instanceof Element) updateLink(event.target.closest('a[href]'));
  }, true);
  document.addEventListener('shopify:section:load', event => decorate(event.target));

  const currentUrl = new URL(location.href);
  if (isSearchUrl(currentUrl) && hasUnderwaterIntent(currentUrl.searchParams.get('q') || '') && normalizeFlatOptions(currentUrl.searchParams)) {
    if (inPreview) currentUrl.searchParams.delete('preview_theme_id');
    currentUrl.searchParams.set(optionName, 'show');
    if (currentUrl.href !== location.href) {
      location.replace(currentUrl.href);
      return;
    }
  }

  decorate(document);
})();
